import { Injectable } from '@angular/core';
import { ActivityTypeModel } from 'src/app/core/models/activity-type.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ActivityTypeService extends BaseService<ActivityTypeModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'activity-type', authService);
  }

  checkDependencies(model: ActivityTypeModel) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/checkDependencies/${model._id}`, {});
  }
}
